// extracted by mini-css-extract-plugin
export var contrastLow = "_3t-1";
export var externalLink = "_3t-2";
export var externalLinkIcon = "_3t-3";
export var link = "_3t-0";
export var linkLabel = "_3t-4";